export enum NotificationCategory {
	InvoicingInformation = "InvoicingInformation",
	DeclarationStatusUpdates = "DeclarationStatusUpdates",
}

export interface NotificationPreferenceResponse {
	category: NotificationCategory
	isEnabled: boolean
}

export interface UpdateNotificationPreferenceRequest {
	category: NotificationCategory
	isEnabled: boolean
}
